import Vue from 'vue'

import KqContainer from './kq-container'
import KqIcon from './kq-icon'
import KqItemTitle from './kq-item-title'
import KqTableConfig from './kq-table-config'
import KqFormConfig from './kq-form-config'
import FormItemPopover from './form-item-popover'
import TablePagination from './table-pagination'

Vue.component('kq-container', KqContainer)
Vue.component('kq-icon', KqIcon)
Vue.component('kq-item-title', KqItemTitle)
Vue.component('kq-table-config', KqTableConfig)
Vue.component('kq-form-config', KqFormConfig)
Vue.component('form-item-popover', FormItemPopover)
Vue.component('table-pagination', TablePagination)
